import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {useApi} from '../hooks/useApi'
import {AuthContextInterface} from '../components/AuthProvider'
import {RootState} from './rootReducer'

//#region types
type SliceState = {
  error: string | null | undefined
  challenge?: Challenge
}

export type Challenge = {
  challengeId: number
  stripePriceId: string
  entriesLimitDate: string
  hasEntry: boolean
}
//#endregion

//#region api
type GetActiveChallengePayload = {
  auth: AuthContextInterface
  reload: boolean
}

export const getActiveChallenge = createAsyncThunk<
  any,
  GetActiveChallengePayload
>('/challenges/active', async ({auth}) => {
  const endpoint = `/v1/are/challenges`

  return useApi(auth, endpoint, {
    method: 'GET',
  }).then(res => res.json())
})

type GetGuestActiveChallengePayload = {
  reload: boolean
}
export const getActiveChallengeGuest = createAsyncThunk<
  any,
  GetGuestActiveChallengePayload
>('/guest/challenges/active', async () => {
  const endpoint = `/v1/guest/are/challenges`

  return useApi(null, endpoint, {
    method: 'GET',
  }).then(res => res.json())
})
//#endregion

//#region slice
const initialState: SliceState = {
  error: undefined,
  challenge: undefined,
}

export default createSlice({
  name: 'guarantee',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getActiveChallenge.fulfilled, (state, action) => {
      state.challenge = action.payload
    })
    builder.addCase(getActiveChallenge.pending, (state, action) => {
      if (action.meta.arg.reload) {
        state.challenge = undefined
      }
    })
    builder.addCase(getActiveChallengeGuest.fulfilled, (state, action) => {
      state.challenge = action.payload
    })
    builder.addCase(getActiveChallengeGuest.pending, (state, action) => {
      if (action.meta.arg.reload) {
        state.challenge = undefined
      }
    })
  },
})
//#endregion

//#region selectors
export const selectActiveChallenge = ({challenge}: RootState) =>
  challenge.challenge
//#endregion
